"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var Image_1 = __importDefault(require("../Image"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var utilities_1 = require("../Themes/utilities");
var DefaultAvatar = require('../assets/DefaultAvatar.svg');
var Wrapper = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  ",
    ";\n"])), function (_a) {
    var onClick = _a.onClick;
    return typeof onClick === 'function' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: 100px;\n      cursor: pointer;\n      &:active,\n      &:focus,\n      &:hover {\n        text-decoration: underline;\n      }\n    "], ["\n      border-radius: 100px;\n      cursor: pointer;\n      &:active,\n      &:focus,\n      &:hover {\n        text-decoration: underline;\n      }\n    "])));
});
var Avatar = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: relative;\n  min-width: ", "px;\n  width: ", "px;\n  height: ", "px;\n  ", "\n"], ["\n  position: relative;\n  min-width: ", "px;\n  width: ", "px;\n  height: ", "px;\n  ",
    "\n"])), function (_a) {
    var avatarSize = _a.avatarSize;
    return avatarSize;
}, function (_a) {
    var avatarSize = _a.avatarSize;
    return avatarSize;
}, function (_a) {
    var avatarSize = _a.avatarSize;
    return avatarSize;
}, function (_a) {
    var noLeftGutter = _a.noLeftGutter;
    if (noLeftGutter) {
        return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
    }
    return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return polished_1.rem(theme.grid.gutterWidth);
    });
});
var NotificationCount = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 4px;\n  color: #fff;\n  position: absolute;\n  top: -8px;\n  right: -7px;\n  font-size: 10px;\n  font-weight: bold;\n  line-height: 19px;\n  text-align: center;\n  white-space: nowrap;\n  padding: 0px 5px;\n  min-width: 17px;\n"], ["\n  background: ", ";\n  border-radius: 4px;\n  color: #fff;\n  position: absolute;\n  top: -8px;\n  right: -7px;\n  font-size: 10px;\n  font-weight: bold;\n  line-height: 19px;\n  text-align: center;\n  white-space: nowrap;\n  padding: 0px 5px;\n  min-width: 17px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
});
var Info = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: none;\n  margin-left: ", ";\n  flex-direction: column;\n  justify-content: center;\n  ", " {\n    display: flex;\n  }\n"], ["\n  display: none;\n  margin-left: ", ";\n  flex-direction: column;\n  justify-content: center;\n  ", " {\n    display: flex;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
}, utilities_1.mb('m'));
var Name = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: ", ";\n  white-space: nowrap;\n"], ["\n  font-size: ", ";\n  white-space: nowrap;\n"])), polished_1.rem(14));
var Subname = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: ", ";\n  white-space: nowrap;\n"], ["\n  font-size: ", ";\n  white-space: nowrap;\n"])), polished_1.rem(10));
var AvatarImage = styled_components_1.default(Image_1.default)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  border-radius: 50%;\n"], ["\n  border-radius: 50%;\n"])));
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.prototype.render = function () {
        var _a = this.props, avatarSrc = _a.avatarSrc, notificationCount = _a.notificationCount, name = _a.name, avatarSize = _a.avatarSize, subname = _a.subname, onClick = _a.onClick, noLeftGutter = _a.noLeftGutter;
        return (React.createElement(Wrapper, { onClick: onClick },
            React.createElement(Avatar, { avatarSize: avatarSize || 32, noLeftGutter: noLeftGutter },
                React.createElement(AvatarImage, { src: avatarSrc || DefaultAvatar, width: avatarSize, height: avatarSize, fallbackSrc: DefaultAvatar }),
                !!notificationCount && (React.createElement(NotificationCount, null, notificationCount >= 100 ? '99+' : notificationCount))),
            (name || subname) && (React.createElement(Info, null,
                name && React.createElement(Name, null, name),
                subname && React.createElement(Subname, null, subname)))));
    };
    return User;
}(React.PureComponent));
exports.default = User;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
